export default __webpack_public_path__ + "static/examp3-bb66d35acd38ec992577cbe8366a710f.gif";